<script>
export default {
    about_us: {
        version: `Budget Control von MlabFactory s.r.l Version `,
        personal_finance: `<b>Persönlicher Finanzmanager</b><p>Budget Control von MlabFactory s.r.l ist ein Tool zur Verwaltung persönlicher Finanzen, das Ihnen hilft, Ihre Ausgaben im Blick zu behalten, damit Sie die Kontrolle behalten und Ihre Ziele erreichen können.</p>`,
        information: `<b>Informationen zu Budget Control</b><p>MlabFactory s.r.l ist ein professioneller Entwickler mit Sitz in Italien, Mailand, der seit 2008 Anwendungen entwickelt. Erfahren Sie mehr über das Team</p><a href="http://mlabfactory.it">Mlabfactory.it</a>`,
        visit_our_website: 'Besuchen Sie unsere Website',
    },
    assistance: {
        write_question: `<p>Stellen Sie hier Ihre Frage</p>`,
        thanks: `Vielen Dank für Ihre Anfrage. Wir werden Ihnen so schnell wie möglich antworten.`,
    },
    profile: {
        policy: `<p>Mit der Registrierung oder Anmeldung über einen der oben genannten Dienste stimmen Sie unseren <a class="font-bold text-decoration-line" href="https://www.budgetcontrol.cloud/terms/">Nutzungsbedingungen</a> zu und erkennen unsere <a class="font-bold text-decoration-line" href="https://www.budgetcontrol.cloud/privacy/">Datenschutzerklärung</a> an, die beschreibt, wie wir Ihre persönlichen Daten verwalten.</p>`
    },
    settings: {
        manage_your_workspace: 'Verwalten Sie Ihre Arbeitsbereiche.',
        manage_wallets: 'Verwalten Sie Ihre Wallets, ändern Sie die Icons und die Farbe.',
        manage_entry: 'Verwalten Sie Ihre Einnahmekategorien.',
        customize_entry: 'Passen Sie die Einnahmeetiketten an.',
        configure_model: 'Konfigurieren Sie die Einnahmemodelle.',
        set_currency: 'Legen Sie Ihre bevorzugte Währung fest.',
        edit_profile: 'Bearbeiten Sie Ihr Benutzerprofil.',
        learn: 'Erfahren Sie mehr über unser Team.',
        write_us: 'Schreiben Sie uns für Unterstützung.',
    },
    install_app: 'Hey! Möchten Sie die Anwendung installieren?',
    tooltips: {
        finalize: {
            workspace: "Der Name Ihres Arbeitsbereichs, damit Sie ihn leicht identifizieren können, falls Sie viele weitere erstellen.",
            currency: "Die Standardwährung, die Sie verwenden, z.B. Euro.",
            wallet: "Der Name Ihres ersten Wallets, z.B. kann es auch der Name Ihrer Bank sein.",
            balance: "Das Anfangsguthaben Ihres Wallets.",
            payment_type: "Die Zahlungsmethode, die Sie am häufigsten verwenden, wir machen sie zum Standard.",
            wallet_type: "Welche Art von Wallet ist es? Eine Bank oder einfach Bargeld? Hier können Sie es auswählen, um Ihre Statistiken zu verbessern."
        }
    }
}
</script>
